const InternationalExpress = () => {
    return(
        <div>
            <div className="">
                <img src="/ExpressBanner/banner-2.jpg" width="100%"/>
            </div>
            <div className="flex flex-col justify-center items-center mb-[1.5rem]">
                <hr className="w-[52rem]"/>
                <div className="lg:flex md:grid flex-1 justify-center items-start mx-auto max-w-[60rem] my-[5rem] gap-5 ">
        
                    <div className="flex flex-col justify-center">
                        <h1 className="font-bold text-3xl text-[#373737]">
                            International Express
                        </h1>
                        <p className="text-sm text-md  lg:max-w-[25rem] md:w-[30rem] mt-[1rem]">
                            The International Express is the umbrella term for all International couriers 
                            operations. It entails all retail, consumer and corporate segments, including 
                            Export Express, Import Express and the Freight Plus—both B2B and B2C. The International 
                            Express’ consumer services include regular document services, discounted document services 
                            PI-2 and PI-3, Student Express—which allows flat rate for educational organisations worldwide, 
                            as well as all international non-Doc services including PN and Special Campaign Box.
                        </p>
                        <p className="text-sm text-md  lg:max-w-[25rem] md:w-[30rem] mt-[1rem]">
                            With stations in the UK, UAE and Canada, TCS International Express is a strong connection, 
                            capable of moving anything and everything to and from Pakistan and for Pakistanis locally 
                            and globally. TCS stays on top of changing trends to ensure the best international courier 
                            and logistics services it provides to its customers.
                        </p>
                        <p className="text-sm text-md  lg:max-w-[25rem] md:w-[30rem] mt-[1rem]">
                            With the diaspora of over 8 million Pakistanis around the world and with rapid proliferation 
                            of connected devices and services, TCS International has immense potential for moving shipments 
                            to and from Pakistan, for Pakistanis globally.
                        </p>
                    </div>
                    <div className="flex-1 flex flex-col justify-center items-center">
                        <img src="/Home/trainingdevelop/traning-1.jpg" alt="" className="max-w-[45rem] h-[30vh]"/>
                    </div>
                </div>
      
            </div>
        </div>
    )
};
export default InternationalExpress;